import React from 'react';
import { QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useAppConfig } from 'providers/AppConfig';
import { onError } from 'api/error/errorHandler';
import { useMockDbSync } from 'hooks/useMockDbSync/useMockDbSync';

const MockDbSyncBridge = () => {
  useMockDbSync();
  return null;
};

export const ReactQueryProvider = ({ children }) => {
  const { CACHE_EXPIRY_IN_MILLISECONDS, QUERYCLIENT_STALETIME_IN_MILLISECONDS } = useAppConfig();

  const queryClient = new QueryClient({
    queryCache: new QueryCache({
      onError: (error, query) => {
        if (!query.meta?.suppressErrorToast) {
          onError(error);
        }
      },
    }),
    defaultOptions: {
      queries: {
        staleTime: CACHE_EXPIRY_IN_MILLISECONDS || 5 * 60 * 1000, // Fallback to 5 minutes if not provided
        gcTime: QUERYCLIENT_STALETIME_IN_MILLISECONDS || 10 * 60 * 1000, // Fallback to 10 minutes if not provided
        refetchOnWindowFocus: false,
      },
    },
  });

  return (
    <QueryClientProvider client={queryClient}>
      <MockDbSyncBridge />
      {children}
    </QueryClientProvider>
  );
};

export default ReactQueryProvider;
